module.exports = __webpack_public_path__ + "static/media/Fitmonkie_Product Listings.f162fec5.docx";